import { atom } from 'jotai';

import { mutationPlaidExchangePublicTokenAtom } from '../_graphql/mutationPlaidExchangePublicToken';
import { mutationPlaidLinkTokenGenerateAtom } from '../_graphql/mutationPlaidLinkTokenGenerate';
import { plaidItemsQueryAtom } from '../_graphql/queryPlaidItems';

// 🔘🔘🔘 PLAIN ATOMS
export const $linkToken = atom<string | null>(null);

// 🟢🟢🟢 REMOTE DATA
export const $remotePlaidItems = plaidItemsQueryAtom(() => ({
  variables: undefined,
}));

// 🟠🟠🟠 ACTION -> GENERATE LINK TOKEN
export const $generateLinkToken = mutationPlaidLinkTokenGenerateAtom({});

// 🟠🟠🟠 ACTION -> EXCHANGE PUBLIC TOKEN
export const $exchangePublicToken = mutationPlaidExchangePublicTokenAtom({});
